import React, { useState, useEffect, useRef } from 'react';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonCheckbox from '../../../common/components/CommonCheckBox/CommonCheckbox';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import _ from 'lodash';
import get from 'lodash/get';
import styles from './Style.module.css';
import Modal from '../../../common/components/Modal/modal';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  getZoneList,
  getCityZoneWiseOrStateWise
} from '../../../common/constants/api';

const validationSchema = Yup.object().shape({
  selectZone: Yup.object().when('panIndia', {
    is: false,
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  isGSTApplicable: Yup.string().required('Required'),
  GSTPercentage: Yup.number().when('isGSTApplicable', {
    is: 'true',
    then: Yup.number()
      .required('Required')
      .min(0, 'Minimun 0 is required')
      .max(99.99, 'Maximun 99.99% is required')
  })
});
const AddBankUnit = ({
  showModal,
  setShowModal,
  addBankUnitFun,
  addBankUnitData
}) => {
  const { modalWidth, modalContainer } = styles;

  return (
    <Formik
      initialValues={{
        panIndia: addBankUnitData?.panIndia,
        selectZone: addBankUnitData?.selectZone,
        selectCity: addBankUnitData?.selectCity,
        branchName: addBankUnitData?.branchName,
        isGSTApplicable: addBankUnitData?.isGSTApplicable,
        GSTPercentage: addBankUnitData?.GSTPercentage
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        setFieldTouched,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => {
        const [zone, setZone] = useState([]);
        const [city, setCity] = useState([]);
        const [show, setShow] = useState(false);

        useEffect(() => {
          getZoneList()
            .then(res => {
              if (res.error) throw new Error(res);
              setShow(false);
              setZone(res);
            })
            .catch(err => {
              setShow(false);
            });
        }, []);

        useEffect(() => {
          if (values?.selectZone?.value !== '') {
            getCityZoneWiseOrStateWise(0, values?.selectZone?.value)
              .then(res => {
                if (res.error) throw new Error(res);
                setShow(false);
                setCity(res);
              })
              .catch(err => {
                setShow(false);
              });
          }
          setFieldValue('selectCity', {
            value: '',
            label: ' Select City'
          });
        }, [values?.selectZone?.value]);

        function zoneOptionsFun() {
          return zone.map(each => {
            return {
              label: each?.name,
              value: each?.id
            };
          });
        }

        function zoneWiseCityOptionsFun() {
          if (city.length !== 0) {
            return city.map(each => {
              return {
                label: each?.name,
                value: each?.id
              };
            });
          } else {
            return [
              {
                label: 'No City Available',
                value: 'No City Available'
              }
            ];
          }
        }

        return (
          <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="pt-2 sm:px-5"
          >
            <Modal
              show={showModal}
              setShow={setShowModal}
              classStyle={modalWidth}
              title="Add Bank Units"
            >
              <div
                style={{
                  borderBottom: '1px solid #DCE9F5',
                  position: 'relative',
                  top: '-5px'
                }}
              ></div>

              <div>
                <div className="pt-4">
                  <CommonCheckbox
                    checked={values?.panIndia}
                    name="panIndia"
                    value={values?.panIndia}
                    onChange={e => {
                      setFieldValue('panIndia', e.target.checked, true);
                    }}
                    onBlur={handleBlur}
                    inputStyles={{
                      background: values?.panIndia == true ? '#FD8023' : 'white'
                    }}
                  />
                  <p className="pl-9 text-black-400">PAN India</p>
                </div>

                <div className={`${modalContainer}`}>
                  <CommonSelect sort={true}
                    disabled={values?.panIndia === true ? true : false}
                    name="selectZone"
                    value={values?.selectZone}
                    onChange={e => {
                      setFieldValue('selectZone', e);
                    }}
                    onBlur={() => {
                      setFieldTouched('selectZone', true, true);
                    }}
                    options={zoneOptionsFun()}
                    dropdownStyle={{
                      top: '52px',
                      fontSize: '16px'
                    }}
                    stylesContainer={{
                      height: '52px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 20px',
                      opacity: values?.panIndia === true ? '0.5' : '1'
                    }}
                    error={
                      touched.selectZone &&
                      get(errors, 'selectZone.value', false)
                    }
                    touched={touched.selectZone}
                  />
                  <CommonSelect sort={true}
                    disabled={values?.panIndia === true ? true : false}
                    name="selectCity"
                    value={values?.selectCity}
                    onChange={e => {
                      setFieldValue('selectCity', e);
                    }}
                    onBlur={() => {
                      setFieldTouched('selectCity', true, true);
                    }}
                    options={zoneWiseCityOptionsFun()}
                    dropdownStyle={{
                      top: '52px',
                      fontSize: '16px'
                    }}
                    stylesContainer={{
                      height: '52px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 20px',
                      opacity: values?.panIndia === true ? '0.5' : '1'
                    }}
                    error={
                      touched?.selectCity &&
                      get(errors, 'selectCity.value', false)
                    }
                    touched={touched?.selectCity}
                  />

                  <CommonInput
                    disabled={values?.panIndia === true ? true : false}
                    legendStyle={{
                      opacity: values?.panIndia === true ? '0.5' : '1'
                    }}
                    name="branchName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.branchName}
                    stylesContainer={{
                      maxWidth: '100%'
                    }}
                    legendName="Enter Branch"
                    error={touched?.branchName && errors?.branchName}
                    errorMsg={errors?.branchName}
                    touched={touched?.branchName}
                  />

                  <div>
                    <p className="text-black-1011 font-medium">
                      Is GST Applicable ?
                    </p>
                    <div className="flex my-3">
                      <div className="flex mr-4">
                        <RadioButton
                          name="isGSTApplicable"
                          value="true"
                          checked={values?.isGSTApplicable === 'true'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <label htmlFor="true" className="mx-4">
                          Yes
                        </label>
                      </div>

                      <div className="flex">
                        <RadioButton
                          name="isGSTApplicable"
                          value="false"
                          checked={values?.isGSTApplicable === 'false'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <label htmlFor="false" className="ml-4">
                          No
                        </label>
                      </div>
                    </div>{' '}
                  </div>

                  {values?.isGSTApplicable == 'true' && (
                    <InputTypeNumber
                      name="GSTPercentage"
                      value={values?.GSTPercentage}
                      maxLength={7}
                      minLength={0}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      rupeeIcon={false}
                      error={touched?.GSTPercentage && errors?.GSTPercentage}
                      errorMsg={errors?.GSTPercentage}
                      touched={touched?.GSTPercentage}
                      setFieldValue={setFieldValue}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        paddingLeft: '15px',
                        letterSpacing: '1px'
                      }}
                      legendStyle={{ paddingLeft: '5px' }}
                      legendName="GST Percentage"
                      rupeeIcon={false}
                      showInText={false}
                    />
                  )}
                </div>
                <button
                  disabled={!_.isEmpty(errors)}
                  onClick={() => {
                    addBankUnitFun(values);
                    setShowModal(false);
                  }}
                  type="submit"
                  className={
                    'submitButton text-16 w-56 h-12 mb-2 font-medium  font-roboto'
                  }
                >
                  Add
                </button>
              </div>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddBankUnit;
